module.exports = __webpack_public_path__ + "static/media/push_black_off.d7522f72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/push_black_off.svg
// module id = 82
// module chunks = 0